import {EntryVersion} from 'notebook/ELNConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';
import {StageEntryDocument} from 'workflows/WorkflowConstants';

export default class StageEntryUpdater extends DocumentEvaluationUpdater<StageEntryDocument, EntryVersion> {
  getDoc(item: StageEntryDocument): EntryVersion {
    return item.entryVersion;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: EntryVersion, oldDoc: EntryVersion | null): void {
    evalTraverser.walkEntryVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: EntryVersion): EntryVersion {
    return mapper.mapEntryVersion(doc, null);
  }

  updatedRoot(root: StageEntryDocument, doc: EntryVersion): StageEntryDocument {
    return {...root, entryVersion: doc};
  }
}
